import React, { useEffect,useState } from "react";
import queryString from "query-string";
import history from "../../history";
import ReactFlow,{ Handle, Position,MiniMap,Controls } from "react-flow-renderer";
import * as elStyle from '../../assets/element';
import {stateDurumEnum} from '../Helpers/Enum';
import {errorMessage} from '../Helpers/Util';
import * as basvuruService from '../../services/basvuruService';
import { Spin } from 'antd';

const parsed = queryString.parse(history.location.search);

const BasvuruWorkflow = () =>  {

  const [spining, setSpining] = useState(false);
 const [element,setElement] = useState([]);

  const graphStyles = { width: "100%", height: "2000px" };
// currentStle
  const loadForm = async () => {
    var data = [];
    var stateIdList = [];
    setSpining(true);
    await basvuruService.BasvuruStateConnector(parsed.basvuruId).then(async resp => {
      const result = resp.data.result;
      if( resp.data.success) {
        await result.stateConnector.map(conn => {
          var revConn = data.filter( d => d.source == conn.targetStateId && d.target == conn.startStateId );
          if(revConn.length > 0 && conn.targetState.stateType != 1){
            revConn.map(el => {
              stateIdList.push({
                stateId : el.source
              })
            });        
        } 

        data.push( { 
          id: conn.connectorId, 
          source: conn.startStateId, 
          target: conn.targetStateId,
          type: "step", 
          arrowHeadType:'arrowclosed', 
          label : conn.eventInfo.description
        });    

        return true;
        });
      
      await result.allStates.map(states => {
        var cStyle = {};

       
        
        if(states.stateDurumuId == stateDurumEnum.Basarili ){
          cStyle = elStyle.finalLabel
        }else if(states.stateDurumuId == stateDurumEnum.IptalEdildi ){
          cStyle = elStyle.cancelLabel
        }else{
          cStyle =  elStyle.progressLabel
        }

        if(states.stateId == result.currentStateId){
         cStyle =  {...cStyle, ...elStyle.currentLabel }
        }

        if( states.stateType == 1) { // initialState
          data.push({ 
            id: "1", 
            sourcePosition : 'top',
            targetPosition: 'bottom',
            className:'circle', 
            style: elStyle.initialLabel, 
            sourcePosition : 'top',targetPosition: 'bottom',
            data: { label: "Kaydet" }, 
            position: { x: 10, y: 10 } },
            { 
              id: "e1",
               source: "1", 
               target: states.stateId,
               type: "step",  
              arrowHeadType:'arrowclosed',
              label : "Kaydet" }
          );
        }
          var connCount = stateIdList.filter( st => st.stateId ==states.stateId);
        
          if(connCount.length > 0){
            data.push({ 
              id: states.stateId,
              className: (states.stateDurumuId == stateDurumEnum.Basarili || states.stateDurumuId == stateDurumEnum.IptalEdildi )  ? 'circle' :  '',
              style: cStyle, 
              data: { label: states.stateDescription}, 
              position: { x: states.stateLeft, y: states.stateTop } ,
             
            });       
          }else{
            data.push({ 
              id: states.stateId,
              className: (states.stateDurumuId == stateDurumEnum.Basarili || states.stateDurumuId == stateDurumEnum.IptalEdildi )  ? 'circle' :  '',
              style: cStyle, 
              data: { label: states.stateDescription}, 
              position: { x: states.stateLeft, y: states.stateTop } ,
              sourcePosition : 'top',
              targetPosition : 'bottom',
            });       
          }
          
      });
      }else{
        errorMessage(result.message);
      }      
    }).catch(ex => {
      errorMessage(String(ex.message));
    });
    setSpining(false);
    setElement(data);
  }

  useEffect(() => {
    loadForm();
  },[]);

    return (
      <>
      <Spin  tip={"Veriler Yükleniyor"} spinning={spining}>     
        {element && 
          <ReactFlow elements={element} style={graphStyles} />
        }       
      </Spin>
      </>
       
    );
}


export default BasvuruWorkflow;
